import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstGnr: [],
		gnr: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, gnr){
			state.gnr = gnr
			if (gnr)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.gnr = null
		},
		setParamsDataTable(state, payload){
			state.lstGnr = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, { gnrdoc, gnrtipo, gnremissor }){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/FiscalDocument/GNRE/Find/${gnrdoc}/${gnrtipo}/${gnremissor}`)
			.then(response => {
				let gnr = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", gnr)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		save(store){
			if (!!store.state.gnr.gnrdoc && !!store.state.gnr.gnrtipo && !!store.state.gnr.gnremissor){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/FiscalDocument/GNRE/Insert", store.state.gnr )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/gnres")
				store.state.gnr = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			await this._vm.$axios.put("/FiscalDocument/GNRE/Update", store.state.gnr )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/gnres")
				store.state.gnr = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/FiscalDocument/GNRE/Delete/${store.state.gnr.gnrdoc}/${store.state.gnr.gnrtipo}/${store.state.gnr.gnremissor}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/gnres")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/FiscalDocument/GNRE/FindList")
			.then(response => {
				let lstGnr = Utils.ValidateAxiosResponse(response.data);
				store.state.lstGnr = lstGnr
				store.state.hasNext = lstGnr.length > store.state.itemsPerPage
			}).catch(error => {
				store.state.lstGnr = []
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/FiscalDocument/GNRE/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstGnr = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async printByOrder(store, vd1pedido){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo GNRE", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/FiscalDocument/GNRE/PrintByOrder/"+vd1pedido, {} )
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);
				if(!!relatPath)
					store.dispatch("print/openRelatsPath", [relatPath], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async generateByOrder(store, vd1pedido){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Emitindo GNRE", indeterminate: true }, {root: true})

			await this._vm.$axios.post("/FiscalDocument/GNRE/GenerateByOrder/"+ vd1pedido)
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);
				if(!!relatPath)
					store.dispatch("print/openRelatsPath", [relatPath], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async existsByOrder(store, vd1pedido){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados de GNRE", indeterminate: true }, {root: true})
			
			let payload = await this._vm.$axios.get(`/FiscalDocument/GNRE/ExistsByOrder/${vd1pedido}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
	}
}